import {
  IconSectionEnterprise1,
  IconSectionEnterprise2,
  IconSectionEnterprise3,
  IconSectionEnterprise4,
  IconSectionEnterprise5,
} from '@/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionEnterpriseSolutionsCloudITServices = () => {
  const { t } = useTranslation();
  const data = [
    {
      number: '01',
      icon: <IconSectionEnterprise1 />,
      title: t('Cloud Migration'),
      desc: t(
        'Transition effortlessly to the cloud with our expert migration services. We ensure secure, efficient, and cost-effective transfers of your applications, data, and workloads to leading platforms like AWS, Azure, or Google Cloud, minimizing downtime and maximizing performance.'
      ),
    },
    {
      number: '02',
      icon: <IconSectionEnterprise2 />,
      title: t('CRM Services'),
      desc: t(
        'Optimize customer relationships with our custom CRM solutions. We design, implement, and integrate CRM systems tailored to your business, enabling better engagement, streamlined processes, and data-driven decision-making.'
      ),
    },
    {
      number: '03',
      icon: <IconSectionEnterprise3 />,
      title: t('SAP Development'),
      desc: t(
        'Unlock the full potential of SAP with our specialized development services. From custom SAP modules to system integration and optimization, we deliver solutions that enhance efficiency and support your enterprise goals.'
      ),
    },
    {
      number: '04',
      icon: <IconSectionEnterprise4 />,
      title: t('System Design Audit'),
      desc: t(
        'Ensure your cloud infrastructure is secure, cost-efficient, and high-performing with our System Design Audit. We assess your architecture against best practices, providing actionable insights to optimize reliability, scalability, and operational excellence.'
      ),
    },
    {
      number: '05',
      icon: <IconSectionEnterprise5 />,
      title: t('QA And Testing'),
      desc: t(
        'We ensure your software performs flawlessly with our comprehensive QA and testing outsourcing services. Our meticulous approach guarantees high-quality, reliable, and secure solutions that meet your business objectives.'
      ),
    },
  ];
  return (
    <div className="section-software-services">
      <p className="label-section">[{t('Enterprise Solutions,Cloud & IT Services')}]</p>
      <div className="list-service">
        {data.map((item) => (
          <div key={item.number} className="item">
            <p className="number">{item.number}</p>
            <div>{item.icon}</div>
            <div>
              <p className="title">{item.title}</p>
              <p className="desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SectionEnterpriseSolutionsCloudITServices);
